export const services = [
  {
    id: 1,
    image: "/assets/services-image/braces.jpg",
    slug: "orthodontics",
  },
  {
    id: 2,
    image: "/assets/services-image/dental-implant.jpg",
    slug: "dental-implants",
  },
  {
    id: 3,
    image: "/assets/services-image/dental-crowns.jpg",
    slug: "dental-crowns",
  },
  {
    id: 4,
    image: "/assets/services-image/decorative-veneers.jpg",
    slug: "decorative-veneers",
  },
  {
    id: 5,
    image: "/assets/services-image/gum-diseases.jpg",
    slug: "gum-diseases",
  },
  {
    id: 6,
    image: "/assets/services-image/impacted-wisdom-teeth-extraction.jpg",
    slug: "wisdom-teeth",
  },
  {
    id: 7,
    image: "/assets/services-image/cosmetic-fillings-preventive-treatments.jpg",
    slug: "cosmetic-fillings",
  },
  {
    id: 8,
    image: "/assets/services-image/root-canal-treatments.jpg",
    slug: "root-canal",
  },
  {
    id: 9,
    image: "/assets/services-image/implantImage.jpg",
    slug: "full-anesthesia-implant",
  },
];
